import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styled from 'styled-components';
import { getMessage } from '../utils';

const Container = styled.div`
  width: 100%;
  text-align: center;
  padding: 50% 0% 0% 0%;
`;

const Title = styled.p`
  font-size: 16px;
  font-family: RobotoBold;
  color: #50626c;
  text-align: center;
  margin: 5% 0% 2% 0%;
  font-weight: 700; 
`;

const Subtitle = styled.p`
  font-size: 14px;
  font-family: RobotoRegular;
  color: #525252;
  text-align: center;
  margin: 5% 15% 2% 15%; 
`;


class ServiceNotAvalible extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: "",
      messageCodeNotAvalible: "CP0001"
    }
  }

  componentDidMount() { 
    const {messages} = this.props
    const {messageCodeNotAvalible} = this.state
    const message = getMessage(messages, messageCodeNotAvalible)
    this.setState({message: message })
  }

  render() {
    const {message} = this.state
    return (
      <Container>
      {
        message
        ?
          <>
          <img 
              src={message.data.icon}
              width={"10%"}
          />
          <Title>{message.data.subject}</Title>
          <Subtitle>{message.data.message}</Subtitle>
          </>
        : <Title>{"Por el momento el servicio no esta disponible"}</Title>
      }
      </Container>

    )
  }
}

function mapStateToProps(state) {
  return {
    messages: state.payments.messages,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
    },
    dispatch,
  );
}

ServiceNotAvalible = connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceNotAvalible);

export default ServiceNotAvalible